export default __webpack_public_path__ + "static/media/DNo.28-5.f67eeea6.jpg";